import React from 'react';
// @ts-ignore
import { HistoryLog, Link, Pager } from 'arag-ui-lib';
import ClaimCommunicatorTemplate from '../claimCommunicationTemplate/claimCommunicatorTemplate';
import styles from './claimCommunicatorCommentsDeleteButton.module.scss';
import codes from '../../utils/constants/codes';
import { decode } from 'html-entities';
import ProgressBar from '../general/progressBar/progressBar';
import { useTranslation } from 'react-i18next';

export type Comments = {
    id: string;
    createdDate: string;
    createdBy: string;
    title: string;
    type: number;
    log: any;
    attachments: null | Array<any>;
    messageId: string;
    isDeletable: boolean;
    visibleToAragOnly: boolean;
    subtitle: string;
};
type Props = {
    comments: Array<Comments>;
    clickDownloadHandler: Function;
    progressFileDownload: any;
    isLoadingDownload: string | null;
    pagerState: any;
    goAtPrevious: Function;
    goAtNext: Function;
    goAtStart: Function;
    goAtEnd: Function;
    goAtPage: Function;
    isDisabled: boolean;
};

const ClaimCommunicatorComments = (props: Props) => {
    const {
        comments,
        clickDownloadHandler,
        isLoadingDownload,
        progressFileDownload,
        pagerState,
        goAtPrevious,
        goAtNext,
        goAtStart,
        goAtEnd,
        goAtPage,
        isDisabled,
    } = props;
    const { t } = useTranslation();
    return (
        <>
            <div className={'row'}>
                <div className={'form-horizontal'}>
                    {comments.map(comment => {
                        return (
                            <div
                                className={`${styles['relative']}`}
                                key={comment.id}
                            >
                                <HistoryLog
                                    id={'historyLog'}
                                    key={comment.id}
                                    createdDate={comment.createdDate}
                                    createdBy={comment.createdBy}
                                    title={comment.title}
                                    subtitle={comment.subtitle}
                                    log={
                                        comment.type &&
                                        (comment.type === 15 ||
                                            comment.type === 14 ||
                                            comment.type === 13) ? (
                                            <ClaimCommunicatorTemplate
                                                log={comment.log}
                                                isDisabled={isDisabled}
                                                clickDownloadHandler={
                                                    clickDownloadHandler
                                                }
                                                isLoadingDownload={
                                                    isLoadingDownload
                                                }
                                                progressFileDownload={
                                                    progressFileDownload
                                                }
                                            />
                                        ) : (
                                            comment.log
                                                .map((item: any) =>
                                                    decode(item, {
                                                        scope: 'strict',
                                                    }),
                                                )
                                                .join(' ')
                                        )
                                    }
                                    attachmentTitle={t('attachments')}
                                    attachments={comment.attachments?.map(
                                        (i: { name: string; id: string }) => {
                                            return {
                                                name: i.name,
                                                downloadFile: (
                                                    <>
                                                        <Link
                                                            id={
                                                                i.id
                                                                    ? `${i.id}_log_item_link`
                                                                    : null
                                                            }
                                                            variant="tertiary"
                                                            arrowDirection="left"
                                                            label={t(
                                                                'download',
                                                            )}
                                                            onClick={async () => {
                                                                await clickDownloadHandler(
                                                                    i.id,
                                                                    i.name,
                                                                    codes.attachment,
                                                                );
                                                            }}
                                                            disabled={
                                                                isDisabled
                                                            }
                                                        />
                                                        {isLoadingDownload ===
                                                            i.id &&
                                                            !progressFileDownload?.find(
                                                                (item: {
                                                                    id: string;
                                                                }) =>
                                                                    item.id ===
                                                                    i.id,
                                                            )?.id && (
                                                                <div
                                                                    className={
                                                                        'row'
                                                                    }
                                                                    style={{
                                                                        marginTop:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    <ProgressBar
                                                                        progress={{
                                                                            id: isLoadingDownload,
                                                                            progress: 0,
                                                                        }}
                                                                        mainStyles={
                                                                            'col-sm-9'
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        {progressFileDownload?.find(
                                                            (item: {
                                                                id: string;
                                                            }) =>
                                                                item.id ===
                                                                i.id,
                                                        )?.id && (
                                                            <div
                                                                className={
                                                                    'row'
                                                                }
                                                                style={{
                                                                    marginTop:
                                                                        '10px',
                                                                }}
                                                            >
                                                                <ProgressBar
                                                                    progress={progressFileDownload?.find(
                                                                        (item: {
                                                                            id: string;
                                                                        }) =>
                                                                            item.id ===
                                                                            i.id,
                                                                    )}
                                                                    mainStyles={
                                                                        'col-sm-9'
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                    </>
                                                ),
                                            };
                                        },
                                    )}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            {comments?.length > 0 ? (
                <div className={'row'}>
                    <Pager
                        pageSize={pagerState.limit || 10}
                        totalItems={pagerState.totalCount}
                        totalPages={pagerState.totalPages}
                        page={pagerState.page || 1}
                        goAtPrevious={goAtPrevious}
                        goAtNext={goAtNext}
                        goAtStart={goAtStart}
                        goAtEnd={goAtEnd}
                        goAtPage={goAtPage}
                    />
                </div>
            ) : null}
        </>
    );
};

export default ClaimCommunicatorComments;
